import { HttpTypes } from "@medusajs/types"
import { clx } from "@medusajs/ui"
import React from "react"
import { colorMap } from "../colorMap"

type OptionSelectProps = {
  option: HttpTypes.StoreProductOption
  current: string | undefined
  updateOption: (title: string, value: string) => void
  title: string
  disabled: boolean
  "data-testid"?: string
}

const OptionSelect: React.FC<OptionSelectProps> = ({
  option,
  current,
  updateOption,
  title,
  "data-testid": dataTestId,
  disabled,
}) => {
  const filteredOptions = (option.values ?? []).map((v) => v.value)
  const isColorOption =
    option.title?.startsWith("Color") || option.title?.startsWith("Base")

  return (
    <div className="flex flex-col gap-y-3">
      <span className="text-sm">Select {title}</span>
      <div className="flex flex-wrap gap-4 pl-1" data-testid={dataTestId}>
        {filteredOptions.map((v) => {
          if (isColorOption) {
            const color = colorMap[v] || v
            const isSelected = v === current
            return (
              <div
                key={v}
                onClick={() => updateOption(option.title, v)}
                style={{
                  cursor: "pointer",
                  backgroundColor: "white",
                  width: 40,
                  height: 40,
                  borderRadius: 100,
                  position: "relative",
                  marginLeft: 6, // Add margin to prevent overflow
                }}
              >
                <div
                  style={{
                    opacity: isSelected ? 1 : 0,
                    position: "absolute",
                    top: -6,
                    left: -6,
                    width: 52,
                    height: 52,
                    backgroundColor: "transparent",
                    borderRadius: 100,
                    border: "3px solid white",
                  }}
                ></div>
                <div
                  style={{
                    backgroundColor: color,
                    width: 34,
                    height: 34,
                    borderRadius: 100,
                    position: "absolute",
                    top: 3,
                    left: 3,
                  }}
                ></div>
              </div>
            )
          }

          return (
            <button
              onClick={() => updateOption(option.title, v)}
              key={v}
              className={clx(
                "border-ui-border-base bg-ui-bg-subtle border text-small-regular h-10 rounded-rounded p-2 flex-1 ",
                {
                  "border-ui-border-interactive": v === current,
                  "hover:shadow-elevation-card-rest transition-shadow ease-in-out duration-150":
                    v !== current,
                }
              )}
              disabled={disabled}
              data-testid="option-button"
            >
              {v}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default OptionSelect
